import { Column, GridRow, NamedEntity } from '@shared';

export class ItemExtend {
  id: string = '';

  @Column({
    title: 'Item Name',
    field: 'itemName',
    order: 2,
    width: 20,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
    filterable: true,
    filterType: 'text',
    type: 'string',
    editable: true,
  })
  itemName: string = '';

  @Column({
    title: 'Item Description',
    field: 'itemDescription',
    order: 3,
    width: 20,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
    filterable: true,
    filterType: 'text',
    type: 'string',
    editable: true,
  })
  itemDescription: string = '';

  @Column({
    title: 'Brink ID',
    field: 'parItemId',
    order: 1,
    width: 10,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
    filterable: true,
    filterType: 'text',
    type: 'string',
  })
  parItemId: string = '';

  @Column({
    title: 'Override',
    field: 'disableParUpdates',
    type: 'boolean',
    filterable: true,
    filterType: 'boolean',
    filterOptions: [
      { name: 'Enabled', value: true },
      { name: 'Disabled', value: false },
    ],
    order: 0.5,
    width: 8,
    align: 'center',
    visibleInQuickView: true,
    editable: true,
  })
  disableParUpdates: boolean = false;

  @Column({
    title: 'PLU',
    field: 'plu',
    order: 5,
    width: 15,
    sortable: true,
    visibleInQuickView: false,
    filterable: true,
    filterType: 'text',
    align: 'left',
    type: 'string',
    editable: true,
  })
  plu: string = '';

  @Column({
    title: 'BKPN',
    field: 'bkpn',
    order: 6,
    width: 18,
    sortable: true,
    visibleInQuickView: false,
    align: 'left',
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    editable: true,
  })
  bkpn: string = '';

  @Column({
    title: 'Revenue Center',
    field: 'revenueCenterId',
    order: 7,
    width: 16,
    sortable: true,
    visibleInQuickView: false,
    align: 'left',
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    editable: true,
  })
  revenueCenterId: number | null = null;

  revenueCenterDescription: string = '';

  @Column({
    title: 'Category Name',
    field: 'categoryId',
    order: 8,
    width: 16,
    sortable: true,
    visibleInQuickView: false,
    align: 'left',
    editable: true,
    type: 'string',
  })
  categoryId: string = '';
  categoryName: string = '';

  productTypeDescription: string = '';

  @Column({
    title: 'Product Type',
    field: 'productType',
    order: 7.5,
    width: 15,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
    filterable: true,
    filterType: 'text',
    editable: true,
    type: 'string',
  })
  productType: string = 'na';

  @Column({
    title: 'Machine Dependencies',
    field: 'dependencies',
    order: 10,
    width: 14,
    visibleInQuickView: false,
    type: 'multiselect',
    filterOptions: [],
    editable: true,
  })
  dependencies: NamedEntity[] = [];

  @Column({
    title: 'Sort Order',
    field: 'sortOrder',
    order: 12,
    width: 14,
    sortable: true,
    visibleInQuickView: true,
    visibleInDetailsView: false,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
  })
  sortOrder: number = 9999;
  @Column({
    title: 'Documents',
    field: 'documentPath',
    order: 13,
    width: 12,
    align: 'left',
    visibleInQuickView: false,
  })
  documentPath: string[] = [];


  @Column({
    title: 'Excluded',
    field: 'isExcluded',
    order: 14,
    width: 10,
    type: 'boolean',
    filterable: true,
    filterType: 'boolean',
    editable: true,
    filterOptions: [
      { name: 'Yes', value: true },
      { name: 'No', value: false },
    ],
  })
  isExcluded: boolean = false;
  
  @Column({
    title: 'Delivery Available',
    field: 'isDeliveryAvailable',
    order: 15,
    width: 10,
    type: 'boolean',
    filterable: true,
    filterType: 'boolean',
    editable: true,
    filterOptions: [
      { name: 'Yes', value: true },
      { name: 'No', value: false },
    ],
  })
  isDeliveryAvailable: boolean = false;

  constructor(item?: Partial<ItemExtend>) {
    Object.assign(this, item);
  }
}

export class GridRowItemExtended extends GridRow(ItemExtend) {}
